import { HomePage, OrdersPage, InventoryPage, MasterDataPage, TraceabilityPage, QualityPage, ProfilePage } from './pages';

const routes = [
    { path: '/home', element: <HomePage /> },
    { path: '/orders', element: <OrdersPage /> },
    { path: '/inventory', element: <InventoryPage /> },
    { path: '/masterdata', element: <MasterDataPage /> },
    { path: '/traceability', element: <TraceabilityPage /> },
    { path: '/quality/*', element: <QualityPage /> }, // Add wildcard (*) for nested routes
    { path: '/profile', element: <ProfilePage /> } 
];

export default routes;
